import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { Card, Column, Row } from 'components/Blocks';

import { useProjectProfile } from '../context';

import { formatCurrency } from 'utils/text';

interface TotalProps {
  title: ReactNode;
  initialValue: number | string;
  currentValue: number | string;
  invoiceValue: number | string;
}

export function TotalRow({ currentValue, initialValue, invoiceValue, title }: TotalProps) {
  const { t } = useLang();
  const { project } = useProjectProfile();

  return (
    <Column>
      <Row
        className="rounded-md bg-primary px-2.5 py-1 font-semibold text-primary-foreground"
        justifyContent="center"
      >
        {title}
      </Row>

      <Row
        className="items-stretch gap-12 font-semibold small_tablet:flex-col small_tablet:gap-7"
        justifyContent="center"
      >
        <Card
          flow="column"
          gap="2"
          className="w-full max-w-72 phone:max-w-full"
          alignItems="center"
        >
          <span>{t('total-initial-metrics')}</span>

          <Row gap="2" justifyContent="center">
            <span className="text-success">{project.currency}</span>

            <span>{formatCurrency(initialValue)}</span>
          </Row>
        </Card>

        <Card
          flow="column"
          gap="2"
          className="w-full max-w-72 phone:max-w-full"
          alignItems="center"
        >
          <span>{t('total-actual-metrics')}</span>

          <Row gap="2" justifyContent="center">
            <span className="text-success">{project.currency}</span>

            <span>{formatCurrency(currentValue)}</span>
          </Row>
        </Card>

        <Card
          flow="column"
          gap="2"
          className="w-full max-w-72 phone:max-w-full"
          alignItems="center"
        >
          <span>{t('total-value-to-be-invoiced')}</span>

          <Row gap="2" justifyContent="center">
            <span className="text-success">{project.currency}</span>

            <span>{formatCurrency(invoiceValue)}</span>
          </Row>
        </Card>
      </Row>
    </Column>
  );
}
